// /home/labdoo/zitech-nexus/frontend/src/pages/admin/CreateCampaign.tsx
import React, { useState } from 'react';
import { newsletterAPI } from '../../services/api';
import './CreateCampaign.css';

// SVG Icons
const Icons = {
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  Preview: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Edit: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 3L21 7L7 21H3V17L17 3Z" />
    </svg>
  ),
  Save: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Clear: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Subject: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7V4h16v3" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  ),
  PreviewText: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 7V4h16v3" />
      <path d="M4 11V8h16v3" />
      <line x1="9" y1="20" x2="15" y2="20" />
      <line x1="12" y1="4" x2="12" y2="20" />
    </svg>
  ),
  Audience: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Content: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16v16H4z" />
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="8" y1="16" x2="12" y2="16" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  Error: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Spinner: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cc-spinner-small">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
};

const CreateCampaign: React.FC = () => {
  const [formData, setFormData] = useState({
    subject: '',
    preview_text: '',
    content: '',
    target_segments: ['all'] as string[]
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [previewMode, setPreviewMode] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSegmentChange = (segment: string) => {
    if (formData.target_segments.includes(segment)) {
      setFormData({
        ...formData,
        target_segments: formData.target_segments.filter(s => s !== segment)
      });
    } else {
      setFormData({
        ...formData,
        target_segments: [...formData.target_segments, segment]
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.subject || !formData.content) {
      setError('Please fill in all required fields');
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      await newsletterAPI.createCampaign(formData);
      setSuccess('Campaign created successfully!');
      setFormData({
        subject: '',
        preview_text: '',
        content: '',
        target_segments: ['all']
      });
      setTimeout(() => setSuccess(''), 3000);
    } catch (err: any) {
      console.error('Error creating campaign:', err);
      setError(err.response?.data?.error || 'Failed to create campaign');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cc-container">
      {/* Header */}
      <div className="cc-header">
        <div className="cc-header-left">
          <button className="cc-back-btn" onClick={() => window.history.back()}>
            <Icons.Back />
            Back
          </button>
          <h1 className="cc-title">Create Newsletter Campaign</h1>
          <p className="cc-subtitle">Design and send email campaigns to your subscribers</p>
        </div>
        <button 
          className={`cc-preview-btn ${previewMode ? 'cc-preview-active' : ''}`} 
          onClick={() => setPreviewMode(!previewMode)}
        >
          {previewMode ? (
            <>
              <Icons.Edit />
              Edit Mode
            </>
          ) : (
            <>
              <Icons.Preview />
              Preview Mode
            </>
          )}
        </button>
      </div>

      {/* Messages */}
      {success && (
        <div className="cc-success">
          <Icons.Check />
          <span>{success}</span>
        </div>
      )}
      {error && (
        <div className="cc-error">
          <Icons.Error />
          <span>{error}</span>
        </div>
      )}

      {/* Preview Mode */}
      {previewMode ? (
        <div className="cc-preview">
          <div className="cc-preview-header">
            <h3 className="cc-preview-title">Email Preview</h3>
            <div className="cc-preview-meta">
              <span>
                <span className="cc-preview-label">Subject:</span>
                {formData.subject || 'No Subject'}
              </span>
            </div>
          </div>
          <div className="cc-preview-body">
            {formData.preview_text && (
              <div className="cc-preview-text">
                {formData.preview_text}
              </div>
            )}
            <div className="cc-preview-content">
              {formData.content || 'No content yet. Start writing your newsletter content.'}
            </div>
          </div>
        </div>
      ) : (
        /* Form */
        <form onSubmit={handleSubmit} className="cc-form">
          <div className="cc-form-grid">
            {/* Left Column */}
            <div className="cc-form-left">
              <div className="cc-card">
                <h3 className="cc-card-title">
                  <Icons.Subject />
                  Campaign Details
                </h3>
                
                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <Icons.Subject />
                    Subject *
                  </label>
                  <input
                    type="text"
                    name="subject"
                    className="cc-form-input"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Enter email subject"
                    required
                  />
                  <span className="cc-form-hint">Keep it short and engaging (50-60 characters recommended)</span>
                </div>

                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <Icons.PreviewText />
                    Preview Text
                  </label>
                  <input
                    type="text"
                    name="preview_text"
                    className="cc-form-input"
                    value={formData.preview_text}
                    onChange={handleChange}
                    placeholder="Brief preview text for inbox"
                  />
                  <span className="cc-form-hint">This appears next to the subject line in email clients</span>
                </div>

                <div className="cc-form-group">
                  <label className="cc-form-label">
                    <Icons.Audience />
                    Target Audience
                  </label>
                  <div className="cc-segments">
                    <label className="cc-segment-label">
                      <input
                        type="checkbox"
                        checked={formData.target_segments.includes('all')}
                        onChange={() => handleSegmentChange('all')}
                      />
                      <span>All Subscribers</span>
                    </label>
                    <label className="cc-segment-label">
                      <input
                        type="checkbox"
                        checked={formData.target_segments.includes('active')}
                        onChange={() => handleSegmentChange('active')}
                      />
                      <span>Active (opened last 30 days)</span>
                    </label>
                    <label className="cc-segment-label">
                      <input
                        type="checkbox"
                        checked={formData.target_segments.includes('recent')}
                        onChange={() => handleSegmentChange('recent')}
                      />
                      <span>Recent (subscribed last 30 days)</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="cc-form-right">
              <div className="cc-card">
                <h3 className="cc-card-title">
                  <Icons.Content />
                  Email Content
                </h3>
                
                <div className="cc-form-group">
                  <label className="cc-form-label">Content *</label>
                  <textarea
                    name="content"
                    className="cc-form-textarea"
                    value={formData.content}
                    onChange={handleChange}
                    rows={15}
                    placeholder="Write your newsletter content here..."
                    required
                  />
                  <span className="cc-form-hint">Use plain text or HTML formatting for your newsletter</span>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="cc-form-actions">
            <button 
              type="button" 
              className="cc-btn-secondary" 
              onClick={() => setFormData({
                subject: '',
                preview_text: '',
                content: '',
                target_segments: ['all']
              })}
            >
              <Icons.Clear />
              Clear
            </button>
            <button type="submit" className="cc-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <Icons.Spinner />
                  Creating...
                </>
              ) : (
                <>
                  <Icons.Save />
                  Create Campaign
                </>
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateCampaign;